import React, { useState, useEffect } from 'react'
import { useTranslation, Trans } from 'react-i18next'

import { TransparentBgButton } from 'components/Shared/Button'
import Textarea from 'components/Shared/Textarea'
import LoadingProgressBar from 'components/Shared/LoadingProgressBar'

import { fetchCustomPrompt, updateCustomPrompt, createCustomPrompt } from 'api/customPrompt'
import { useToast } from 'components/Shared/AppToast/ToastProvider'
import ErrorMessage from 'components/Shared/ErrorMessage'

function CoCreatePromt() {
  const [isEditingMode, setIsEditingMode] = useState(false)
  const [isDefault, setIsDefault] = useState(true)
  const [initialCustomPrompt, setInitialCustomPrompt] = useState(null)
  const [prompt, setPrompt] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(false)
  const [isSaving, setIsSaving] = useState(false)

  const { t, i18n } = useTranslation()
  const { addNotification } = useToast()

  const isDeLanguage = i18n.language === 'de'

  useEffect(() => {
    async function getCustomPrompt() {
      setIsLoading(true)
      setError(false)

      const result = await fetchCustomPrompt()

      if (result.success) {
        setInitialCustomPrompt(result.data?.prompt)
        setPrompt(result.data?.prompt)
        setIsDefault(!result.data?.custom_prompt_enabled)
        setIsEditingMode(!result.data?.prompt)
      } else {
        setError(true)
      }

      setIsLoading(false)
    }
    getCustomPrompt()
  }, [])

  const handleSave = async () => {
    setIsSaving(true)

    let result = null
    if (initialCustomPrompt) {
      result = await updateCustomPrompt({ prompt, custom_prompt_enabled: 'true' })
    } else {
      result = await createCustomPrompt({ prompt, custom_prompt_enabled: 'true' })
    }

    if (result.success) {
      setIsEditingMode(false)
    } else {
      addNotification({
        message: t('common.genericError'),
        description: t('common.errors.inServerResponse'),
        variant: 'error',
      })
    }

    setIsSaving(false)
  }

  const saveDefaultPromt = async () => {
    setIsDefault(true)

    const result = await updateCustomPrompt({ prompt, custom_prompt_enabled: 'false' })

    if (!result.success) {
      setIsDefault(false)
      addNotification({
        message: t('common.genericError'),
        description: t('common.errors.inServerResponse'),
        variant: 'error',
      })
    }
  }

  const saveCustomPromt = async () => {
    setIsDefault(false)

    if (!initialCustomPrompt) {
      return
    }

    const result = await updateCustomPrompt({ prompt, custom_prompt_enabled: 'true' })

    if (!result.success) {
      setIsDefault(true)
      addNotification({
        message: t('common.genericError'),
        description: t('common.errors.inServerResponse'),
        variant: 'error',
      })
    }
  }

  // return
  return (
    <div className="co-create-promt">
      <div className={`first-row ${isDeLanguage ? 'de-langauge' : ''}`}>
        <div className="settings-page__sectionState flex-wrap">
          <h3 className="settings-page__sectionTitle">{t('Settings.system.coCreatePromt.title')}</h3>

          <p className="settings-page__sectionValue d-block">
            <Trans
              i18nKey="Settings.system.coCreatePromt.description"
              components={{
                span: <span style = {{fontWeight: 600,}}>Custom</span>,
              }}
            />
          </p>
        </div>

        {isLoading ? 
          <LoadingProgressBar visible/> 
          :         
          <div className="co-create-promt__buttons">
            <button
              onClick={saveDefaultPromt}
              className={isDefault ? 'active btn' : 'btn'}
            >
              {t('Settings.system.coCreatePromt.default')}
            </button>

            <button
              onClick={saveCustomPromt}
              className={!isDefault ? 'active btn' : 'btn'}
            >
              {t('Settings.system.coCreatePromt.custom')}
            </button>
          </div>}


      </div>

      {!isDefault && !isLoading && (           
        <div className={`second-row mt-2 ${isDeLanguage ? 'de-langauge' : ''}`}>
          <Textarea
            placeholder={t('Settings.system.coCreatePromt.placeholder')}
            value={prompt || ''}
            name="promt"
            onChange={(e) => setPrompt(e.target.value)}
            maxLength={2500}
            showMax
            rows={5}
            disabled={!isEditingMode}
          />

          {
            isEditingMode ? 
              <TransparentBgButton
                color="navy"
                text={t('Settings.system.coCreatePromt.buttonSave')}
                onClick={handleSave}
                disabled={isSaving || !prompt}
                extraStyles={{ width: 'fit-content' }}
              /> 
              :
              <TransparentBgButton
                color="navy"
                text={t('Settings.system.coCreatePromt.buttonEdit')}
                onClick={() => setIsEditingMode((prev) => !prev)}
                extraStyles={{ width: 'fit-content' }}
              />
          }



        </div>
      )}

      {error && <ErrorMessage classNames="mt-2 mb-0" danger>Error fetching custom prompt, please try again later.</ErrorMessage>}
    </div>
  )
}

export default CoCreatePromt